import './ReactTitle.scss'
import { ReactTitleProps } from './types'
import { getSpacing } from '../../utils/spacing-util'
import IsInEditorText from '../shared/IsInEditorText'

const ReactTitle = ({
  id = '',
  style,
  text = '',
  isInEditor = false,
  top = false,
  right = false,
  bottom = false,
  left = false,
  lob = ''
}: ReactTitleProps) => {
  return (
    <>
      {IsInEditorText(isInEditor, 'React Title')}
      <div
        id={id}
        data-testid={`react-title`}
        className={`react-title ${style} ${getSpacing(top, right, bottom, left, true)} ${lob}`}
      >
        {text}
      </div>
    </>
  )
}
export default ReactTitle
